<div style="display: block">
    <div [chart]="chart"></div>
</div>

<div class="card border-warning mb-3" *ngIf="!data?.length">
    <div class="card-body">
        <h5 class="card-title" style="font-size: medium; ">SIN DATOS PARA GRAFICAS</h5>
    </div>
</div>
